import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import BusSearch from "../components/BusSearch";
import CabSearch from "../components/CabSearch";
import TrainSearch from "../components/TrainSearch";
import FlightSearch from "../components/FlightSearch";
import HotelSearch from "../components/HotelSearch";
import Destinations from "../components/Destinations";
import Packages from "../components/Packages";
import Fleet from "../components/Fleet";
import WhyChoose from "../components/WhyChoose";
import Testimonials from "../components/Testimonials";
import CTABanner from "../components/CTABanner";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Services />
        <BusSearch />
        <CabSearch />
        <FlightSearch />
        <HotelSearch />
        <TrainSearch />
        <Destinations limit={5} />
        <Packages limit={3} />
        <WhyChoose />
        <Fleet />
        <Testimonials />
        <CTABanner />
      </main>
      <Footer />
    </>
  );
};

export default Home;
